export default "__VITE_ASSET__jwi6IuDE__"